"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupTermsConditions = exports.FULL_TERMS = exports.CHANNELS = exports.getAffiliates = exports.CHANNEL_FRIENDLY_NAMES = exports.Channel = void 0;
var Channel;
(function (Channel) {
    Channel["RENTALS_UNITED"] = "rentalsunited.com";
    Channel["RENTALS_UNITED_DESPEGAR"] = "rentalsunited.com:despegar.com.ar";
    Channel["RENTALS_UNITED_EDOMIZIL"] = "rentalsunited.com:e-domizil.com";
    Channel["RENTALS_UNITED_EXPEDIA"] = "rentalsunited.com:expedia.com";
    Channel["RENTALS_UNITED_TOURICO"] = "rentalsunited.com:touricoholidays.com";
    Channel["RENTALS_UNITED_TRIPADVISOR"] = "rentalsunited.com:tripadvisor.com";
    // AirBnB
    Channel["AIRBNB"] = "airbnb.com";
    // Booking.com & affiliates
    Channel["BOOKINGCOM"] = "booking.com";
    Channel["BOOKINGCOM_AGODA"] = "booking.com:agoda.com";
    Channel["BOOKINGCOM_KAYAK"] = "booking.com:kayak.com";
    Channel["BOOKINGCOM_PRICELINE"] = "booking.com:priceline.com";
    // Expedia & affiliates
    Channel["EXPEDIA"] = "expedia.com";
    Channel["EXPEDIA_HOTELSCOM"] = "expedia.com:hotels.com";
    Channel["EXPEDIA_EXPEDIA_AFFILIATE_NETWORK"] = "expedia.com:expediaaffiliatenetwork";
    Channel["EXPEDIA_EGENCIA"] = "expedia.com:egencia.com";
    Channel["EXPEDIA_TRAVELOCITY"] = "expedia.com:travelocity.com";
    Channel["EXPEDIA_ORBITZ"] = "expedia.com:orbitz.com";
    Channel["EXPEDIA_WOTIF"] = "expedia.com:wotif.com";
    Channel["EXPEDIA_HOTWIRE"] = "expedia.com:hotwire.com";
    Channel["EXPEDIA_CHEAPTICKETS"] = "expedia.com:cheaptickets.com";
    Channel["EXPEDIA_EBOOKERS"] = "expedia.com:ebookers.com";
    Channel["EXPEDIA_MRJET"] = "expedia.com:mrjet.com";
    Channel["EXPEDIA_LASTMINUTEAU"] = "expedia.com:lastminute.au";
    Channel["EXPEDIA_AMERICAN_EXPRESS_TRAVEL"] = "expedia.com:americanexpresstravel";
    Channel["EXPEDIA_AMEX_THE_HOTEL_COLLECTION"] = "expedia.com:amexthehotelcollection";
    Channel["EXPEDIA_AMEX_FINE_HOTELS_AND_RESORTS"] = "expedia.com:amexfinehotelsandresorts";
    Channel["EXPEDIA_THOMAS_COOK"] = "expedia.com:thomascook.com";
    Channel["EXPEDIA_NECKERMANN"] = "expedia.com:neckermann.de";
    Channel["EXPEDIA_VING"] = "expedia.com:ving.se";
    Channel["EXPEDIA_TJAREBORG"] = "expedia.com:tjareborg.fi";
    Channel["EXPEDIA_SPIES"] = "expedia.com:spies.dk";
    // Holidu
    Channel["HOLIDU"] = "holidu.co.uk";
    // HomeToGo
    Channel["HOMETOGO"] = "hometogo.com";
    // HomeAway & affiliates
    Channel["HOMEAWAY"] = "homeaway.co.uk";
    Channel["HOMEAWAY_ARBITEL"] = "homeaway.co.uk:arbitel.fr";
    // TripAdvisor & affiliates
    Channel["TRIPADVISOR"] = "tripadvisor.com";
    Channel["TRIPADVISOR_FLIPKEY"] = "tripadvisor.com:flipkey.com";
    Channel["TRIPADVISOR_HOUSETRIP"] = "tripadvisor.com:housetrip.com";
    Channel["TRIPADVISOR_HOLIDAYLETTINGS"] = "tripadvisor.com:holidaylettings.com";
    // Direct Bookings
    Channel["TRAVELNEST"] = "direct";
})(Channel = exports.Channel || (exports.Channel = {}));
exports.CHANNEL_FRIENDLY_NAMES = {
    // for internal/admin use only
    [Channel.RENTALS_UNITED]: 'Rentals United',
    [Channel.RENTALS_UNITED_DESPEGAR]: 'Despegar',
    [Channel.RENTALS_UNITED_EDOMIZIL]: 'E-domizil',
    [Channel.RENTALS_UNITED_EXPEDIA]: 'Expedia',
    [Channel.RENTALS_UNITED_TOURICO]: 'Tourico',
    [Channel.RENTALS_UNITED_TRIPADVISOR]: 'TripAdvisor',
    // AirBnB
    [Channel.AIRBNB]: 'Airbnb',
    // Booking.com direct
    [Channel.BOOKINGCOM]: 'Booking.com',
    [Channel.BOOKINGCOM_AGODA]: 'Agoda',
    [Channel.BOOKINGCOM_KAYAK]: 'Kayak',
    [Channel.BOOKINGCOM_PRICELINE]: 'Priceline',
    // Holidu
    [Channel.HOLIDU]: 'Holidu',
    // HomeToGo
    [Channel.HOMETOGO]: 'HomeToGo',
    // HomeAway & affiliates
    [Channel.HOMEAWAY]: 'HomeAway',
    [Channel.HOMEAWAY_ARBITEL]: 'Arbitel',
    // Expedia & affiliates
    [Channel.EXPEDIA]: 'Expedia',
    [Channel.EXPEDIA_HOTELSCOM]: 'Hotels.com',
    [Channel.EXPEDIA_EXPEDIA_AFFILIATE_NETWORK]: 'Expedia Affiliate Network',
    [Channel.EXPEDIA_EGENCIA]: 'Egencia',
    [Channel.EXPEDIA_TRAVELOCITY]: 'Travelocity',
    [Channel.EXPEDIA_ORBITZ]: 'Orbitz',
    [Channel.EXPEDIA_WOTIF]: 'Wotif',
    [Channel.EXPEDIA_HOTWIRE]: 'Hotwire',
    [Channel.EXPEDIA_CHEAPTICKETS]: 'CheapTickets',
    [Channel.EXPEDIA_EBOOKERS]: 'ebookers',
    [Channel.EXPEDIA_MRJET]: 'MrJet',
    [Channel.EXPEDIA_LASTMINUTEAU]: 'Lastminute.au',
    [Channel.EXPEDIA_AMERICAN_EXPRESS_TRAVEL]: 'American Express Travel',
    [Channel.EXPEDIA_AMEX_THE_HOTEL_COLLECTION]: 'Amex The Hotel Collection',
    [Channel.EXPEDIA_AMEX_FINE_HOTELS_AND_RESORTS]: 'Amex Fine Hotels and Resorts',
    [Channel.EXPEDIA_THOMAS_COOK]: 'Thomas Cook',
    [Channel.EXPEDIA_NECKERMANN]: 'Neckermann',
    [Channel.EXPEDIA_VING]: 'Ving',
    [Channel.EXPEDIA_TJAREBORG]: 'Tjareborg',
    [Channel.EXPEDIA_SPIES]: 'Spies',
    // TripAdvisor & affiliates
    [Channel.TRIPADVISOR]: 'TripAdvisor',
    [Channel.TRIPADVISOR_FLIPKEY]: 'FlipKey',
    [Channel.TRIPADVISOR_HOUSETRIP]: 'HouseTrip',
    [Channel.TRIPADVISOR_HOLIDAYLETTINGS]: 'HolidayLettings',
    // Direct Bookings
    [Channel.TRAVELNEST]: 'Direct Bookings'
};
const getAffiliates = (channelId) => {
    const filteredChannelList = Object.entries(exports.CHANNEL_FRIENDLY_NAMES).filter((ch) => ch[0].startsWith(channelId) && ch[0] !== channelId);
    return filteredChannelList.map((cl) => cl[1]);
};
exports.getAffiliates = getAffiliates;
exports.CHANNELS = [
    {
        id: Channel.AIRBNB,
        display_name: 'Airbnb',
        affiliates: (0, exports.getAffiliates)(Channel.AIRBNB),
        marketingLink: 'https://travelnest.com/marketing-channels/airbnb-advertising/',
    },
    {
        id: Channel.BOOKINGCOM,
        display_name: 'Booking.com',
        affiliates: (0, exports.getAffiliates)(Channel.BOOKINGCOM),
        marketingLink: 'https://travelnest.com/marketing-channels/booking-com-advertising/',
        commission: 19,
    },
    {
        id: Channel.EXPEDIA,
        display_name: 'Expedia',
        affiliates: (0, exports.getAffiliates)(Channel.EXPEDIA),
        marketingLink: 'https://travelnest.com/marketing-channels/expedia-advertising/',
    },
    {
        id: Channel.HOMEAWAY,
        display_name: 'VRBO',
        affiliates: (0, exports.getAffiliates)(Channel.HOMEAWAY),
        marketingLink: 'https://travelnest.com/marketing-channels/homeaway-advertising/',
    },
    {
        id: Channel.HOLIDU,
        display_name: 'Holidu',
        affiliates: (0, exports.getAffiliates)(Channel.HOLIDU),
        detail: 'A worldwide vacation rental search engine with over 30 million users per month.'
    },
    {
        id: Channel.HOMETOGO,
        display_name: 'HomeToGo',
        affiliates: (0, exports.getAffiliates)(Channel.HOMETOGO),
        detail: "HomeToGo is the marketplace with the world's largest selection of holiday homes. A global brand name that's making incredible homes easily accessible to everyone."
    },
    {
        id: Channel.TRIPADVISOR,
        display_name: 'TripAdvisor',
        affiliates: (0, exports.getAffiliates)(Channel.TRIPADVISOR),
        marketingLink: 'https://travelnest.com/marketing-channels/tripadvisor-advertising/',
    },
    {
        id: Channel.TRAVELNEST,
        display_name: 'Direct Bookings',
        affiliates: (0, exports.getAffiliates)(Channel.TRAVELNEST),
        detail: 'Let visitors to your own marketing channels and repeat guests book directly though Travelnest.'
    },
];
exports.FULL_TERMS = `Who we are

Travelnest Limited trading as Travelnest (“we/us/our” or “Travelnest”) is a limited liability company incorporated in England. Our company number is 09141571, and our registered office is at Ground Floor, 2 Woodberry Grove, London, England, N12 0DR.


About these terms of service

These are the terms of service (“Terms”) which apply to all use of our property marketing services (“Service”) through our platform https://account.travelnest.com/.

By registering and using our Service, you are entering into a legal binding agreement with us based on these Terms (referred to as the “Agreement”). A copy of these Terms can also be found within our Help Centre at https://travelnest.freshdesk.com/support/solutions/articles/101000365056-travelnest-terms-and-conditions.

We reserve the right to amend these Terms from time to time. If the changes are deemed material, we will e-mail you to alert you to our new Terms. Your continued use of the Service will be deemed to be acceptance of any new Terms.


About the Service

We are providing an online property marketing service. This means that we facilitate the online logistics associated with marketing a holiday home, including:

• marketing your properties on your selected property listing websites (“channels”);

• building, integrating and optimising your listings on your selected channels;

• dealing with guest enquiries and pre-arrival questions; and

• processing payments from your channels and guests.

Please note that we are not responsible for any on-site services (e.g. such as cleaning, maintenance or repairs).


Scope of our Services

When you use our Service, we will market your properties and manage bookings for you. However, please note that when we do so we act as your agent.

This means that when we market your properties on your selected channels, you are entering into a direct (legally binding) contractual relationship with the relevant channel. Likewise, when we take a booking on your behalf, you are entering into a direct (legally binding) contract with your guest to provide your accommodation services (your “Owner Services”) in accordance with your own terms and conditions. We act solely as an intermediary between (i) you and your channels; and (ii) you and your guests.

It also means that when you use our Service, you appoint us as a payment collection agent solely for the limited purpose of accepting payment from your channels or guests in connection with the provision of your Owner Services. You agree that payment made by a channel and/or guest through Travelnest shall be considered the same as a payment made directly to you, and you will provide your Owner Services in the agreed-upon manner as if you received the payment directly from the channel or guest (as applicable). You also agree that we may refund a channel and/or guest in accordance with the channel cancellation policy as reflected in the Service at the time of booking . Our obligation to pay you is subject to and conditional upon successful receipt of the associated payments from the channel and guest. In accepting appointment as a limited payment collection agent we assume no liability for any of your, or your channel or guests, acts or omissions.


About our bookings

When we take a booking on your behalf, we will check your Travelnest calendar to ensure that you have availability on the requested dates. When we confirm the booking we will update your Travelnest calendar accordingly.

Please note that it is your responsibility to keep your Travelnest calendar up-to-date at all times, and to check availability, before making any external booking. If we accept a booking for your Travelnest calendar, this will take precedence over any conflicting booking that was not in your Travelnest calendar at the time of the booking.


Cancellations of guest bookings

The prepayment and cancellation terms applicable to each channel are displayed in the Service under Marketing.  Some channels may allow a grace/cooldown period after booking that allows the guest to cancel the transaction during this period. If you request us to cancel a booking after we have confirmed the booking with the guest, we reserve the right to charge you any costs incurred as a result such as relocation or cancellation fees as well as an administration fee on behalf of Travelnest of £50 plus VAT. If we are responsible for changes or cancellations to a booking and fees are charged by a channel or other reasonable costs are incurred, we will not seek to recover these from you.


About your selected channels

Please note that when you select a channel through our Service, you are also accepting and agreeing to the relevant terms and conditions of that channel. Links to each channels' terms and conditions are available in our Service under Marketing and we advise you to read these carefully.

Channels do not permit duplicate listings of properties. Your Travelnest listing will take priority over any listing that you chose to manage yourself on the same channel. If we become aware that your property has a duplicate listing, we will contact you to discuss whether you wish to continue listing with Travelnest or manage the listing yourself. Please note that the channel may also remove duplicate listings which is out-with our control.

You will be responsible for compliance with each of your selected channels' terms and conditions.

If we are obliged to pay a fee to a channel as a result of your breach of such terms and conditions, then we shall be entitled to a refund of such costs from you. This includes any cancellation costs which we incur as a result of your breach, and any travel costs we may be required to reimburse your guests on your behalf due to such cancellation. We may offset any such costs against any money we may owe to you or request that you refund these costs to us.


Your obligations
You must comply with the terms of the Agreement as set out in these Terms.

To qualify to use the Service you must meet the following criteria, and accordingly you warrant that you: are over 18; have full authority to enter into this Agreement; have full authority to list the property(ies); are not currently restricted from using the Service; will only use the Service for your legitimate interests; shall not infringe our rights, including intellectual property rights we may have in our Service; and shall only submit information that you are entitled to submit, which is accurate and not confidential.

In order to meet the qualifying criteria to use our Service, we have a verification process in place which you and your properties will be entered into upon agreeing to use our Services. This process is in line with our respective channel partners and is expected to take no longer than two weeks to complete. During this time we retain the right to temporarily pause listing properties that do not meet our criteria. We also retain the right to withhold submitting your first payment per property until the validation processes is complete.

You are responsible for managing and updating your account and all information contained therein on the Service and ensuring it is kept secure and up to date. If you discover any un-authorised use of your Account you must promptly let us know. We reserve the right to disable any user account at any time if, in our opinion, you have failed to comply with any of the provisions of these Terms. For the avoidance of doubt this obligation applies during the notice period of the Agreement.

You must comply with our Acceptable Use policy as set out below.

You agree to indemnify us against all damages, losses and costs which we incur due to your failure to comply with this Agreement.

Acceptable Use

• You must not store or transmit any material during your use of the Service that is unlawful, dishonest, threatening, defamatory, obscene, discriminatory or racially offensive.

• You must not send or transmit any material which infringes any third party intellectual property rights.

• You must not create a false identity or submit inaccurate, false or misleading information.

• You must not transmit any unsolicited advertising such as spam or junk mail.

• You should not knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful.

• You must not attempt to gain un-authorised access to our Service, the server on which our Service is stored or any server, computer or database connected to our Service.


Your rights
On condition that you comply with your obligations under the Agreement, we grant you a limited, non-exclusive, non-transferable licence to access and use the Service in accordance with this Agreement.


Prices, fees, important terms and payments
Price

You are responsible for setting the minimum price for each of your properties (which we refer to as the “base price”). We will never list your properties on any channel for less than the base price you have set.

Both the channel and Travelnest reserve the right to add a booking fee inclusive of VAT to your base price.


Fees

Use of the Service is free, however we will charge our commission payment plus VAT based on the base value and cleaning fees from each booking made using our Service. Your commission rate per channel will be displayed in the Service under Marketing. Commissions will not be charged if a guest cancels a booking and receives a full refund. If a guest receives a partial refund we will charge our commission on value of the base price not refunded.

In addition to commissions, we will retain any booking fee added to your base price. We do not retain booking fees added by channels.


Important terms

We reserve the right to vary your commission rate during the term of this Agreement. However, we shall give you at least 90 days' notice in writing of any proposed changes to the commission rate.


Payments

We will release payment to you within 3-10 days after arrival.

The amount that we will deduct from each booking is detailed in the Fees section above and will include VAT if you are based in the United Kingdom. If you are VAT registered, you can claim back this VAT. You will receive a VAT invoice whenever a payment is being sent to you detailing what we are paying you for along with any commission or other deductions being charged.

Should a refund out-with the standard terms of the booking be agreed between yourself and the guest, you will bear the full cost of this refund and will be required to return any funds that have already been remitted to you including any cancellation costs incurred within 30 days of the cancellation.

When a guest challenges a charge made by them on a credit card, known as a “chargeback”, we will be notified by our credit card payment provider (“provider”). Once notified, we have a period of time to defend the chargeback using all the information available to us in relation to the booking. We will submit all information that we have available within the required timescales, however, the final decision lies with our provider. Should the provider agree with our defense, no further action will be required and you will still be entitled to payment for the booking. However, if the provider does not agree with our defence, they will refund the guest and we will, therefore, have to reclaim the value of the booking from you as if this was a cancellation of a booking. We will either request you to send these funds to us by bank transfer or we may be able to offset the amount against a future payout.


Cancellation of this contract

You may cancel your Account at any time by giving us 30 days' notice (“cancellation period”). We require this 30-day cancellation period to off-board your properties from your selected channels.

To cancel your Account, please contact us at owners@travelnest.com.

Cancellation shall not affect any existing bookings, nor any bookings that may be made during the 30-day cancellation period, which you are obliged to honour. For the avoidance of doubt, this includes all existing bookings and all bookings made during the cancellation period, regardless of the relevant check-in date for each booking. At the end of the 30-day cancellation period, your Agreement with us will be terminated and we will not be entitled to make further bookings on your behalf. If you do not wish to have bookings during the 30 day cancellation period, you are responsible for blocking the dates on your Travelnest calendar to prevent any bookings from being made.

We reserve the right to terminate this contract at any time by giving you 30 days notice. This may be as a result of failure to comply with these Terms and Conditions, failure to comply with channel listing requirements or any other reason that will communicated to you such as a higher than normal cancellation rate. This could include, but is not limited to: acting in a non-professional manner or not having the legal right to advertise properties listed on the Service.


Our rights in the Service

We own or validly license all intellectual property rights in our Service, and in the material published on it.  Except to the extent set out in the Agreement, or otherwise agreed in writing between us, you are not permitted to use such intellectual property rights.


Availability of Service

We shall use reasonable endeavours to make the Service available 24 hours a day, seven days a week, except for planned or unplanned maintenance.


Data Protection

We shall process all personal data in accordance with our Privacy Policy and we shall both comply with our respective obligations under applicable data protection legislation.


Disclaimer of warranties

The Service is provided on an 'as is' and 'as available' basis and to the extent permitted under English law, without warranties of any kind. In particular we make no warranty that the Service will meet your requirements or expectations or that it will be error free. We make no warranty regarding any transaction concluded between you and a guest or in connection with the Service, and you understand that each such transaction is entered into at your own risk.


Liability
Non-exclusion

We do not exclude or limit in any way our liability for:

• death or personal injury caused by our negligence or the negligence of our employees, agents or subcontractors;

• fraud or fraudulent misrepresentation; or

• any matter for which it would be unlawful to exclude or restrict liability.


Our liabilities

If we fail to comply with these Terms, we are responsible for loss or damage you suffer that is a result of our breach of the Terms or our failure to use reasonable care and skill.

We are not liable to you for any business losses. If you use the Service for any commercial, business or re-sale purpose we will have no liability to you for such losses, including any loss of profit, loss of business, business interruption, or loss of business opportunity.

Other than as stated in the non-exclusion section above, in no event shall we be liable to you (whether in contract, tort (including negligence), equity (including restitution), breach of statutory duty, or otherwise) for:

• any defects, errors or omissions in any information, materials or instructions provided by you to us in connection with the Service, or any actions taken by us at your direction; or

• any indirect or consequential loss arising under or in connection with the Agreement; or

• any loss of profit, loss of revenue, loss of use, loss of goodwill, loss of data, business interruption or loss of anticipated savings, whether direct or indirect; or

• any ex gratia payment or sum paid in settlement of a claim without our prior written approval.

Our total liability to you in respect of all other loss or damage arising under or in connection with the Agreement shall in no circumstances exceed the sum of the Commission received by us during the 12-month period preceding the date on which the claim arose.

This section shall survive termination of the Agreement.


Indemnity

You agree to indemnify us against all claims, loss or damage which we sustain or are likely to sustain as a consequence of your breach of the Agreement, including your breach of any of the terms and conditions of your selected channels.


General

If we choose to waive any particular right we have under the Agreement on any particular occasion this does not prevent us from exercising that right on another occasion.

If any part of the Agreement is held by a court of law (or similar forum) to be invalid or unenforceable, this shall not affect the validity or enforceability of the rest of the Agreement.

You are not entitled to transfer or assign your rights and obligations under the Agreement to anyone else without our prior written permission.

If there are any disputes arising out of your use of the Service, or otherwise relating to the Agreement, then these will be governed by English law and subject to the exclusive jurisdiction of the English Courts.
`;
exports.SignupTermsConditions = [
    {
        termsId: 'terms20200318',
        termsName: 'Travelnest terms and conditions',
        termsUrl: 'https://travelnest.freshdesk.com/support/solutions/articles/101000365056-travelnest-terms-and-conditions',
        fullTerms: exports.FULL_TERMS
    }
];
//# sourceMappingURL=constants.js.map